import { useLocation, useNavigate } from "react-router-dom";
import { Avatar, Button, Card, Col, Empty, Row, Skeleton } from "antd";
import { useEffect, useState } from "react";
import "../Products/Product-Detail.scss";
import { capitalizeString } from "../../../shared/util";
import { getData } from "../../../controllers/capacities";
import { UserOutlined } from "@ant-design/icons";
import { routerData } from "../..";

const ProductDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  let { params } = location.state;
  const [product, setProduct] = useState([] as any);
  const [loading, setLoading] = useState<boolean>(true);

  const go = (params: routerData, entity: any) => {
    navigate(`/${entity}/${params.id}`, { state: { params, entity } });
  };

  useEffect(() => {
    const getProduct = async () => {
      const response = await getData("products", {
        filter: `filter[id][_eq]=${params.id}&`,
      });

      if (response.length > 0) {
        setProduct(response[0]);
        setLoading(false);
      }
    };

    getProduct();
  }, []);

  return (
    <div style={{ width: "100%", height: "max-content" }}>
      <h1 className="conection-heading-section">Datos generales</h1>
      <Skeleton loading={loading} active className="full-width">
        <Card
          className="ant-card-conection"
          onClick={() => {}}
          hoverable
          style={{ width: "100%", marginBottom: 30 }}
        >
          <Row gutter={[8, 8]} style={{ width: "100%", marginBottom: 20 }}>
            <Col xs={24} sm={12} md={8} lg={12}>
              <h2 className="conection-label">Producto</h2>
              <p className="conection-value">
                {capitalizeString(product.nme_producto_pd)}
              </p>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={8}
              lg={12}
              style={{ width: "100%", marginBottom: 20 }}
            >
              <h2 className="conection-label">Capacidad</h2>
              <p className="conection-value">
                {capitalizeString(
                  product.capacity_type?.capacities || "Sin descripcion"
                )}
              </p>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12}>
              <h2 className="conection-label">Tipología</h2>
              <p className="conection-value">
                {capitalizeString(product.nme_tipologia_pd)}
              </p>
            </Col>
          </Row>
        </Card>

        <>
          <h1 className="conection-heading-section">Investigadores</h1>
          <Card
            className="ant-card-conection ant-card-conection-border"
            onClick={() => {}}
            hoverable
            style={{ width: "100%", marginBottom: 30 }}
          >
            <Row gutter={[8, 8]} className="full-width">
              <Col xs={24} sm={12} md={8} lg={24}>
                {!product?.searchers || product.searchers?.length === 0 ? (
                  <Empty description={"0 Registros"} />
                ) : null}
              </Col>
            </Row>
            <Row gutter={[8, 8]}>
              {product?.searchers?.map((s: any) => (
                <Col lg={12} key={s.id}>
                  <div
                    onClick={() => {
                      go(
                        {
                          id: s.searchers_id.id,
                          name: s.searchers_id.nombre,
                          type: s.searchers_id.actor_type.actor,
                        },
                        "searchers"
                      );
                    }}
                    style={{ marginBottom: 20 }}
                    className="flex with-pointer"
                  >
                    <Avatar icon={<UserOutlined />} />
                    <p className="profile-info">
                      {`${s?.searchers_id?.nombre}` || ""}
                      <span>{`${s?.searchers_id?.nme_niv_form_pr}` || ""}</span>
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
            <Row />
          </Card>
        </>
        <>
          <h1 className="conection-heading-section">Grupos</h1>
          <Card
            className="ant-card-conection ant-card-conection-border"
            onClick={() => {}}
            hoverable
            style={{ width: "100%", marginBottom: 30 }}
          >
            <Row gutter={[8, 8]} className="full-width">
              <Col xs={24} sm={12} md={8} lg={24}>
                {!product?.groups || product.groups?.length === 0 ? (
                  <Empty description={"0 Registros"} />
                ) : null}
              </Col>
            </Row>
            <Row gutter={[8, 8]}>
              {product?.groups?.map((s: any) => (
                <Col lg={12} key={s.id}>
                  <Button
                    className="connection-font"
                    size="middle"
                    onClick={() => {
                      go(
                        {
                          id: s.groups_id?.id,
                          name: s.groups_id?.nme_grupo_gr,
                          type: s.groups_id?.actor_type?.actor,
                        },
                        "groups"
                      );
                    }}
                    style={{ marginBottom: 10, marginRight: 20, width: "auto" }}
                  >
                    {capitalizeString(s.groups_id.nme_grupo_gr)}
                  </Button>
                </Col>
              ))}
            </Row>
            <Row />
          </Card>
        </>
      </Skeleton>
    </div>
  );
};

export default ProductDetail;
